import { render, staticRenderFns } from "./stockList.vue?vue&type=template&id=93725a42"
import script from "./stockList.vue?vue&type=script&lang=js"
export * from "./stockList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports